var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.width && _vm.height)?_c('div',{style:({
  width:(_vm.width + "px"),
  height:(_vm.height + "px")
})},[_c('Iframe',{staticClass:"iframe1",attrs:{"url":_vm.url,"Authorization":_vm.Authorization,"customerId":_vm.customerId,"id":"iframe1"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }